var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.team.subscriptionExpired() ||
    _vm.team.trialExpiring() ||
    _vm.team.subscriptionExpiring()
    ? _c("div", { staticClass: "full-width" }, [
        _vm.team.trialExpiring() && _vm.showHint
          ? _c(
              "div",
              {
                staticClass: "row bg-blue-grey text-blue-grey-2 q-py-sm q-px-lg"
              },
              [
                _c("div", { staticClass: "row items-center full-width" }, [
                  _c(
                    "div",
                    { staticClass: "col-auto" },
                    [
                      _c("q-icon", {
                        staticStyle: { "font-size": "1.5rem" },
                        attrs: { name: "info", color: "blue-grey-2" }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col q-px-md" },
                    [
                      _c(
                        "i18n",
                        { attrs: { tag: "span", path: "trial_expiring" } },
                        [
                          _c(
                            "span",
                            { attrs: { place: "trialExpirationDate" } },
                            [_vm._v(_vm._s(_vm.team.trialExpirationDate()))]
                          ),
                          _c(
                            "a",
                            {
                              staticClass: "text-blue-grey-1 text-bold",
                              attrs: { place: "settings", href: "#" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.openSettings($event)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$tc("setting", 2)))]
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-auto" },
                    [
                      _c("q-icon", {
                        staticClass: "cursor-pointer",
                        staticStyle: { "font-size": "1.5rem" },
                        attrs: { name: "close" },
                        nativeOn: {
                          click: function($event) {
                            return _vm.hideHint($event)
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              ]
            )
          : _vm._e(),
        _vm.team.subscriptionExpiring() && _vm.showHint
          ? _c(
              "div",
              {
                staticClass:
                  "row justify-start bg-warning text-white q-py-sm q-px-lg"
              },
              [
                _c("div", { staticClass: "row items-center full-width" }, [
                  _c(
                    "div",
                    { staticClass: "col-auto" },
                    [
                      _c("q-icon", {
                        staticStyle: { "font-size": "1.5rem" },
                        attrs: { name: "info", color: "white" }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col q-px-md" },
                    [
                      _c(
                        "i18n",
                        {
                          attrs: { tag: "span", path: "subscription_expiring" }
                        },
                        [
                          _c(
                            "span",
                            { attrs: { place: "subscriptionExpirationDate" } },
                            [
                              _vm._v(
                                _vm._s(_vm.team.subscriptionExpirationDate())
                              )
                            ]
                          ),
                          _c(
                            "a",
                            {
                              staticClass: "text-white text-bold",
                              attrs: { place: "settings", href: "#" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.openSettings($event)
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$tc("setting", 2)))]
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "col-auto" },
                    [
                      _c("q-icon", {
                        staticClass: "cursor-pointer",
                        staticStyle: { "font-size": "1.5rem" },
                        attrs: { name: "close" },
                        nativeOn: {
                          click: function($event) {
                            return _vm.hideHint($event)
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              ]
            )
          : _vm._e()
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }